var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./dropdownMenuContent.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4a942072\"}!../../../../vue-loader/lib/selector?type=template&index=0!./dropdownMenuContent.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/edoc-library/src/components/dropdownMenu/dropdownMenuContent.vue
// module id = 681
// module chunks = 42